<template>
	<DividerAutoDirection>{{ $t('base-stations-edit.fields.baselinesDivider') }}</DividerAutoDirection>
	<Row>
		<Col span="24" :lg="{ span: 12 }">
			<FormItem :label="$t('base-stations-edit.fields.baselinesActiveLabel')">
				<div v-if="baselineIds.length > 0" :class="baselinesBlockClasses">
					<router-link
						v-for="baselineId in baselineIds"
						:key="baselineId"
						:to="{ name: 'baselines-edit', params: { id: baselineId } }"
					>
						{{ $t('baselines.lineId') }} #{{ baselineId }}
					</router-link>
				</div>
				<div v-else class="pd-sm-x">
					{{ $t('base-stations-edit.fields.noBaselines') }}
				</div>
			</FormItem>
		</Col>
	</Row>
</template>

<script>
import { toRef, computed } from 'vue';
import { Row, Col, FormItem } from 'ant-design-vue';

import DividerAutoDirection from '@/components/common/DividerAutoDirection.vue';

export default {
	components: { Row, Col, FormItem, DividerAutoDirection },
	props: ['baseStationObj'],
	setup(props) {
		const baseStationObjRef = toRef(props, 'baseStationObj');
		const baselineIds = computed(() => {
			const uniqueIds = [...new Set(baseStationObjRef.value.baselineIds)];
			uniqueIds.sort((a, b) => a - b);
			return uniqueIds;
		});
		const baselinesBlockClasses = computed(() => {
			let result = ['pd-sm-x', 'baselines-block'];
			if (baselineIds.value.length > 1) {
				result.push('baselines-block-many');
			}
			return result;
		});
		return {
			baselineIds,
			baselinesBlockClasses,
		};
	},
};
</script>

<style scoped>
.baselines-block {
	margin-top: 0;
	display: flex;
	flex-direction: column;
	align-items: flex-start;
}

.baselines-block-many {
	margin-top: 5px;
}
</style>
